import { httpCreate } from './http';

const http = httpCreate('/srv/game-participant');

export const gamePart = {
	// 小游戏参与详情
	getGamePart(activityId, gameId, params) {
		return http.get(`/${activityId}?gameId=${gameId}`, { params });
	},
	operatorGame(id, formData) {
		return http.put(`/operator/${id}`, formData);
	},
};
